import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart, Music2 } from 'lucide-react';
import { DanceParticlesProps } from '../../types/judge';

/**
 * Dynamic floating elements with dance-inspired movement
 * Creates animated particles that float across the screen with dance-themed icons
 */
const DanceParticles: React.FC<DanceParticlesProps> = ({ className = '' }) => {
  const createParticle = (index: number) => {
    // Create a grid-based distribution with some randomness
    const cols = 6;
    const rows = 2;
    const col = index % cols;
    const row = Math.floor(index / cols);
    
    const baseX = (col / cols) * 1920; // Desktop width
    const baseY = (row / rows) * 1080; // Desktop height
    
    // Add some randomness to avoid perfect grid
    const randomOffsetX = (Math.random() - 0.5) * (1920 / cols);
    const randomOffsetY = (Math.random() - 0.5) * (1080 / rows);
    
    return {
      startX: baseX + randomOffsetX,
      startY: baseY + randomOffsetY
    };
  };

  const renderParticleIcon = (index: number) => {
    const iconProps = { className: "w-3 h-3 drop-shadow-lg" };
    
    switch (index % 4) {
      case 0:
        return <Star {...iconProps} className={`${iconProps.className} text-pink-400`} />;
      case 1:
        return <Heart {...iconProps} className={`${iconProps.className} text-red-400`} />;
      case 2:
        return <Music2 {...iconProps} className={`${iconProps.className} text-purple-400`} />;
      case 3:
        return <div className="w-2 h-2 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full drop-shadow-lg" />;
      default:
        return <Star {...iconProps} className={`${iconProps.className} text-pink-400`} />;
    }
  };

  return (
    <div className={`fixed inset-0 overflow-hidden pointer-events-none z-10 ${className}`}>
      {/* Particles disabled for performance - keeping container for future re-enable */}
      {/* 
      {[...Array(12)].map((_, i) => {
        const { startX, startY } = createParticle(i);
        
        return (
          <div
            key={i}
            className="absolute opacity-30"
            style={{
              left: startX,
              top: startY,
              transform: 'scale(0.6)'
            }}
          >
            {renderParticleIcon(i)}
          </div>
        );
      })}
      */}
    </div>
  );
};

export default DanceParticles;
